import React, { useEffect, useState } from "react";
import { Container, Row, Carousel } from "react-bootstrap";

import styles from "./Experience.module.css";
import { getExperience } from "../../Firebase/FirebaseFetch";
import { HashLoader } from "react-spinners";
import { AnimatePresence, motion } from "framer-motion";

function Experience(props) {
  const [experience, setExperience] = useState([]);
  // const [fetchExp, setFetchExp] = useState([]);
  useEffect(() => {
    getExperience().then((res) => {
      setExperience(res);
    });
  }, []);

  return (
    <Container id="experience" className={styles.experience}>
      <div>
        <Row>
          {experience.length === 0 ? (
            <div className="d-flex justify-content-center">
              <HashLoader color="#ffffff" />
            </div>
          ) : (
            <AnimatePresence>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <Row>
                  <h3
                    className={`${styles.heading} text-center text-md-start animate__animated animate__fadeInLeft`}
                  >
                    My <span className={styles.important}>Experience</span>
                  </h3>
                </Row>

                <Row>
                  <Carousel style={{ position: "unset" }}>
                    {experience.map((item, index) => {
                      console.log(item?.startDate);
                      return (
                        <Carousel.Item key={index} className={styles.slideItem}>
                          <div className="mb-4">
                            <div className={styles.headerTop}>
                              <div>
                                <p className={`${styles.title} ms-sm-4 mb-0 `}>
                                  {item.designation.stringValue}
                                </p>
                                <p className={`${styles.title} ms-sm-4 mb-0 `}>
                                  {item.company.stringValue}
                                </p>
                                <p className={`${styles.title} ms-sm-4 mb-0 `}>
                                  {item.location.stringValue}
                                </p>
                              </div>
                              <div
                                style={{
                                  textAlign: "end",
                                }}
                              >
                                <p className={styles.counter}>
                                  0
                                  <span className={styles.important}>
                                    {index + 1}
                                  </span>
                                </p>
                                <p className={styles.title}>
                                  {item.startDate?.stringValue}
                                  <span className={`${styles.important} px-2`}>
                                    /
                                  </span>
                                  {item.endDate?.stringValue}
                                </p>
                              </div>
                            </div>
                            <p className={`${styles.desc} ms-sm-4 mt-3 `}>
                              {item.description.stringValue}
                            </p>
                            <div className="mt-2">
                              {item.points.arrayValue.values.map((p, i) => {
                                return (
                                  <li key={i} className={`${styles.desc} `}>
                                    {p.stringValue}
                                  </li>
                                );
                              })}
                            </div>
                          </div>
                        </Carousel.Item>
                      );
                    })}
                  </Carousel>
                </Row>
              </motion.div>
            </AnimatePresence>
          )}
        </Row>
      </div>
    </Container>
  );
}

export default Experience;
